import axios from "axios";
window.axios = axios

import $ from 'jquery'
window.$ = window.jQuery = $

import 'jquery-ui/ui/core'
import 'jquery-ui/ui/widgets/autocomplete'

require('bootstrap')
require('bootstrap-datepicker')
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.zh-TW.min')